/* eslint-disable no-mixed-operators */
import React from "react";
import "./App.scss";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import classes from './App.module.scss';
// Pictures
import BoschBandSrc from "./assets/pictures/BoschBand.png";
import BoschLogoSrc from "./assets/pictures/BoschLogo.png";
// Fabric components
import "office-ui-fabric-react/dist/css/fabric.min.css";
import { ProgressIndicator } from "@fluentui/react/lib/ProgressIndicator";
import LoadingDialog from "./core/components/LoadingDialog";
import TopNavigation from "./core/common/TopNavigation";
import _ from "lodash";
import RbLabel from "./bosch-react/components/label/RbLabel";
import RbDivider from "./bosch-react/components/divider/RbDivider";
import RbButton, { ButtonSize } from "./bosch-react/components/button/RbButton";
import "./bosch-react/style.scss";
import "./bosch-react/color.scss";
import "./bosch-react/icon.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Color from "./core/libraries/Color";
import { faRssSquare } from "@fortawesome/free-solid-svg-icons";
import { Router } from "./core/common/Router";
import { RootState } from "./store/store";
import { connect } from "react-redux";
import ConfirmationDialog from "./features/Dialog/components/ConfirmationDialog";
import { Login, ProviderState, Providers } from "@microsoft/mgt-react";
import { getCurrentUserInfoDispatch } from "./features/Auth/thunks";
import Toaster from "./core/components/Toaster";
import { apiCallRequest } from "./features/Auth/authConfig";
import { getMyBookmarks } from "./features/Bookmark/services";
import { getDivisionsList } from "./services/commonServices";
import { OpenOutlookLink } from "./core/common/OpenOutlookLink";
import { SupportEmailTemplate } from "./core/libraries/Template";
import Constants from "./core/libraries/Constants";
import NotificationBar from "./features/Admin/NotificationSetting/NotificationBar/NotificationBar";
import ChatWindow from "./features/OpenAI/Chat/ChatWindow";
import { ChatModes } from "./features/OpenAI/types";
import Version from "./core/components/Version/Version";
interface AppState {
  isHomePage: boolean;
  routers: any;
  isSignedIn: boolean;
  shouldShowChat: boolean;
}
class App extends React.Component<any, AppState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isHomePage: false,
      routers: null,
      isSignedIn: false,
      shouldShowChat: false,
    };
  }

  updateState = () => {
    const mgtProvider = Providers.globalProvider;
    this.setState({
      isSignedIn: mgtProvider && mgtProvider.state === ProviderState.SignedIn,
    },
    )
  }

  async componentDidMount() {
    Providers.onProviderUpdated(this.updateState);
    this.updateState();

    const mgtProvider = Providers.globalProvider;

    if (mgtProvider && (mgtProvider.state === ProviderState.SignedIn || mgtProvider.state === ProviderState.SignedOut)) {
      await this.ensureValidAccessToken();
    }

    // Wait up to 10 seconds for the state to change
    const startTime = Date.now();
    while (!this.state.isSignedIn && Date.now() - startTime < 10000) {
      await new Promise((resolve) => setTimeout(resolve, 1000)); // Wait 1 second
    }

    // If still not signed in after 10 seconds, clear storage & refresh
    if (mgtProvider.state !== ProviderState.SignedIn) {
      console.warn("User not signed in after 10s. Clearing storage & refreshing...");
      localStorage.clear();
      window.location.reload();
    }
  }

  ensureValidAccessToken = async () => {
    const mgtProvider = Providers.globalProvider;
    try {
      const token = await mgtProvider.getAccessToken({ scopes: apiCallRequest.scopes });

      if (!token && mgtProvider.state !== ProviderState.Loading) { // ✅ Prevent duplicate login
        await mgtProvider.login!();
      }
    } catch (error) {
      console.log(error);
      await mgtProvider.login!();
    }
  };

  determineShouldShowChat = () => {
    return this.props.userProfile?.menuFeatures?.some((feature: any) =>
      (feature.featureName === ChatModes.ADVANCED_CHAT || feature.featureName === ChatModes.STANDARD_CHAT) && feature.hasAccess);
  }

  componentWillUnmount(): void {
    Providers.removeProviderUpdatedListener(this.updateState);
  }

  handleLoginCompleted = async (e: any) => {
    await Providers.globalProvider.getAccessToken({
      scopes: apiCallRequest.scopes
    }).then(async (token: any) => {
      this.props.getCurrentUserInfoDispatch(token);
    })

    await getMyBookmarks();
    await getDivisionsList();
  }

  renderLoading = <div className="ms-Grid" style={{ width: "100vw", height: "100vh" }}>
    <div
      className="ms-Grid-row"
      style={{ width: "100vw", height: "100vh", textAlign: "center", position: "absolute" }}
    >
      <div
        style={{ width: "50vw", marginTop: "45vh", marginLeft: "25vw" }}
      >
        <ProgressIndicator
          label="FEBER is loading"
          description="Please wait for some seconds ..."
        />
      </div>
    </div>
  </div>

  render() {
    let mainContent: any =
      <>
        <div className="Header">
          <div className="ms-Grid">
            <div className="ms-Grid-row">
              <img
                className="bosch-band"
                src={BoschBandSrc}
                alt="Bosch Brand"
              />
              <div className="ms-Grid-col left-area">
                <a href={process.env.REACT_APP_HOME}>
                  <img src={BoschLogoSrc} alt="Bosch Logo" />
                </a>
                <TopNavigation />
              </div>
              <div className="ms-Grid-col right-area">
                <Login loginView="compact" loginCompleted={(event) => this.handleLoginCompleted(event)} loginFailed={(event) => console.log(event)} />
                <div style={{ display: "inline-block" }}>
                  <OpenOutlookLink recipient={Constants.FEBER_MAILBOX_ADDRESS} subject={Constants.SUPPORT_SUBJECT} body={SupportEmailTemplate} />
                </div>
                <RbButton
                  className={classes.feedbackButton}
                  style={{ float: "right" }}
                  size={ButtonSize.Small}
                  onClick={() => {
                    window.open(process.env.REACT_APP_FEEDBACK_URL, "_blank");
                  }}
                />
              </div>
            </div>
            <div className="ms-Grid-row">
              <RbDivider />
              <NotificationBar />
            </div>
          </div>
        </div>
        <div className="Main-Content">
          <Router />
          {this.props.userProfile && this.determineShouldShowChat() && < ChatWindow />}
          <p style={{ marginTop: "40px" }} />
        </div>
        {/* Footer section */}
        <div className="Footer">
          <div className="info">
            <RbLabel style={{ fontWeight: "bold" }}>
              © {new Date().getFullYear()} Robert Bosch GmbH
            </RbLabel>
            <a
              href={process.env.REACT_APP_PRIVATE_POLICY_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <RbLabel>Privacy Policy</RbLabel>
            </a>
            <RbLabel>Sitemap</RbLabel>
            <RbLabel>Mobile Site</RbLabel>
            <a
              href={process.env.REACT_APP_RSS_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                style={{
                  color: Color.ORANGE,
                  fontSize: "18px",
                  marginBottom: "-2px",
                }}
                icon={faRssSquare}
              />
            </a>
            <Version />
          </div>
          <img className="bosch-band" src={BoschBandSrc} alt="Bosch Brand" />
        </div>
        {/* <SupportPanel /> */}
      </>;
    return (
      <>
        {!this.props.userProfile && this.renderLoading}
        <div className="ms-Fabric" dir="ltr">
          {!!this.state.isSignedIn && mainContent}
          <Toaster />
          <LoadingDialog />
          <ConfirmationDialog />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  userProfile: state.auth.userProfile,
  dialogMessage: state.util.dialogMessage,
});


export default connect(mapStateToProps, { getCurrentUserInfoDispatch })(App);
